// import React, { useEffect, useState } from "react";
// import { Container, Alert } from "@mui/joy";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import FilterHeader from "../components/FilterHeader";
// import LeadCard from "../components/LeadCard";
// import { subDays } from "date-fns";

// axios.defaults.withCredentials = true;

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const LeadsListPage = () => {
//   const [leads, setLeads] = useState([]);
//   const [filterOptions, setFilterOptions] = useState({
//     startDate: subDays(new Date(), 7),
//     endDate: new Date(),
//     project: [],
//   });
//   const [isLoading, setIsLoading] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [error, setError] = useState(null);
//   const [agentlist, setagentlist] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/projectdetails/project/56/agents`, {
//         withCredentials: true,
//       })
//       .then((response) => {
//         setagentlist(response.data);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);

//   const fetchProjects = async () => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/projectdetails/user/projects`
//       );
//       if (response.data) {
//         const formattedProjects = [
//           { id: 0, name: "All Projects" },
//           ...response.data.map((project) => ({
//             id: project.id,
//             name: project.project_name,
//           })),
//         ];
//         setProjects(formattedProjects);
//       }
//     } catch (error) {
//       setError("Failed to fetch projects");
//       console.error("Error fetching projects:", error);
//     }
//   };

//   const fetchLeads = async (filters = filterOptions) => {
//     setIsLoading(true);
//     try {
//       try {
//         const response = await axios.get(
//           `${BASE_URL}/leads/user/leads`,
//           // payload,
//           {
//             withCredentials: true,
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         console.log(response.data.data);
//         setLeads(response.data.data);
//         if (response.data?.list) {
//           setLeads(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching leads:", error);
//       }
//     } catch (error) {
//       console.error("Error fetching leads:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProjects();
//     fetchLeads();
//   }, []);

//   const handleDateChange = (newFilter) => {
//     setFilterOptions(newFilter);
//   };

//   const handleProjectChange = (projectId) => {
//     setFilterOptions((prev) => ({ ...prev, project: projectId }));
//   };

//   const handleFilter = () => {
//     fetchLeads(filterOptions);
//   };

//   const handleViewDetails = (lead) => {
//     localStorage.setItem("leaddetails", JSON.stringify(lead));
//     navigate("/clients/dashboard");
//   };

//   if (error) {
//     return (
//       <Container sx={{ py: 4 }}>
//         <Alert color="danger" variant="soft">
//           {error}
//         </Alert>
//       </Container>
//     );
//   }

//   return (
//     <Container sx={{ py: 4 }}>
//       <FilterHeader
//         filterOption={filterOptions}
//         onDateChange={handleDateChange}
//         onProjectChange={handleProjectChange}
//         onFilter={handleFilter}
//         projects={projects}
//         setLeads={setLeads}
//       />

//       <div className="space-y-4">
//         {isLoading ? (
//           <div className="flex justify-center items-center py-8">
//             <div className="animate-pulse text-gray-500">Loading leads...</div>
//           </div>
//         ) : leads.length === 0 ? (
//           <div className="text-center py-8 text-gray-500">
//             No leads found for the selected filters
//           </div>
//         ) : (
//           leads.map((lead) => (
//             <LeadCard
//               key={lead.id}
//               lead={lead}
//               onViewDetails={() => handleViewDetails(lead)}
//               agentlist={agentlist}
//               assignedagent={lead.agent_id}
//             />
//           ))
//         )}
//       </div>
//     </Container>
//   );
// };

// export default LeadsListPage;

import React, { useEffect, useState } from "react";
import { Container, Alert } from "@mui/joy";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FilterHeader from "../components/FilterHeader";
import LeadCard from "../components/LeadCard";
import { subDays } from "date-fns";

axios.defaults.withCredentials = true;

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LeadsListPage = () => {
  const [leads, setLeads] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    startDate: subDays(new Date(), 7),
    endDate: new Date(),
    project: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [agentlist, setagentlist] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${BASE_URL}/projectdetails/project/56/agents`, {
        withCredentials: true,
      })
      .then((response) => {
        setagentlist(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/projectdetails/user/projects`
      );
      if (response.data) {
        const formattedProjects = [
          { id: 0, name: "All Projects" },
          ...response.data.map((project) => ({
            id: project.id,
            name: project.project_name,
          })),
        ];
        setProjects(formattedProjects);
      }
    } catch (error) {
      setError("Failed to fetch projects");
      console.error("Error fetching projects:", error);
    }
  };

  const fetchLeads = async (filters = filterOptions) => {
    setIsLoading(true);
    try {
      try {
        const response = await axios.get(
          `${BASE_URL}/leads/user/leads`,
          // payload,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data.data);
        setLeads(response.data.data);
        if (response.data?.list) {
          setLeads(response.data);
        }
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchLeads();
  }, []);

  const handleDateChange = (newFilter) => {
    setFilterOptions(newFilter);
  };

  const handleProjectChange = (projectId) => {
    setFilterOptions((prev) => ({ ...prev, project: projectId }));
  };

  const handleFilter = () => {
    fetchLeads(filterOptions);
  };

  const handleViewDetails = (lead) => {
    localStorage.setItem("leaddetails", JSON.stringify(lead));
    navigate("/clients/dashboard");
  };

  const handleSort = (sortType) => {
    let sortedLeads = [...leads];

    switch (sortType) {
      case "date-newest":
        sortedLeads.sort(
          (a, b) => new Date(b.created_time) - new Date(a.created_time)
        );
        break;
      case "date-oldest":
        sortedLeads.sort((a, b) => {
          const dateA = new Date(a.created_time);
          const dateB = new Date(b.created_time);
          return dateA - dateB;
        });
        break;
      case "conversations-most":
        sortedLeads.sort(
          (a, b) => (b.conversation_count || 0) - (a.conversation_count || 0)
        );
        break;
      case "conversations-least":
        sortedLeads.sort((a, b) => {
          const countA = a.conversation_count || 0;
          const countB = b.conversation_count || 0;
          return countA - countB;
        });
        break;
      default:
        break;
    }

    setLeads(sortedLeads);
  };

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert color="danger" variant="soft">
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <FilterHeader
        filterOption={filterOptions}
        onDateChange={handleDateChange}
        onProjectChange={handleProjectChange}
        onFilter={handleFilter}
        projects={projects}
        setLeads={setLeads}
      />

      <div className="mb-4 flex justify-end">
        <div className="relative inline-block text-left">
          <select
            className="px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSort(e.target.value)}
            defaultValue=""
          >
            <option value="">Sort by...</option>
            <option value="date-newest">Date (Newest First)</option>
            <option value="date-oldest">Date (Oldest First)</option>
            <option value="conversations-most">Most Conversations</option>
            <option value="conversations-least">Least Conversations</option>
          </select>
        </div>
      </div>
      <div className="space-y-4">
        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-pulse text-gray-500">Loading leads...</div>
          </div>
        ) : leads.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No leads found for the selected filters
          </div>
        ) : (
          leads.map((lead) => (
            <LeadCard
              key={lead.id}
              lead={lead}
              onViewDetails={() => handleViewDetails(lead)}
              agentlist={agentlist}
              assignedagent={lead.agent_id}
            />
          ))
        )}
      </div>
    </Container>
  );
};

export default LeadsListPage;
